export default {
  styleOverrides: {
    content: {
      margin: "6px 0!important",
    }
  }
};
